import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "./api";

const Ctx = createContext(null);

/** Customer session (email/password or Google) — `user` is undefined while checking, null when signed out. */
export const CustomerAuthProvider = ({ children }) => {
  const [user, setUser] = useState(undefined);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/account/me");
      setUser(data);
      return data;
    } catch {
      setUser(null);
      return null;
    }
  }, []);

  useEffect(() => {
    // CRITICAL: when returning from Google, AuthCallback exchanges the session_id first.
    if (window.location.hash?.includes("session_id=")) return;
    refresh();
  }, [refresh]);

  const login = async (email, password) => setUser((await api.post("/account/login", { email, password })).data);
  const register = async (name, email, password) => setUser((await api.post("/account/register", { name, email, password })).data);
  const logout = async () => {
    await api.post("/account/logout");
    setUser(null);
  };
  const loginWithGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/account";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return <Ctx.Provider value={{ user, setUser, refresh, login, register, logout, loginWithGoogle }}>{children}</Ctx.Provider>;
};

export const useCustomer = () => useContext(Ctx);
